import { automapAdminPortalPath } from "../constants/automapAdminPortalPaths";
import { isSuperAdminUser } from "./superAdmin";

/** Partner portal and post-login routing helpers. */

const INTERNAL_ADMIN_PERMISSIONS = [
  "users.manage",
  "real_estate.sources.manage",
  "system.audit.view",
  "roles.manage",
];

export function hasPartnerAccess(user) {
  if (!user) {
    return false;
  }

  return (
    user.permissions?.includes("partner_dashboard.view") &&
    (user.partnerOrganizations?.length > 0 ||
      hasInternalAdminAccess(user))
  );
}

export function hasInternalAdminAccess(user) {
  if (!user) {
    return false;
  }

  if (isSuperAdminUser(user)) {
    return true;
  }

  const permissions = user.permissions || [];
  return INTERNAL_ADMIN_PERMISSIONS.some((code) => permissions.includes(code));
}

export function getPrimaryPartnerOrganization(user) {
  if (!user?.partnerOrganizations?.length) {
    return null;
  }

  return (
    user.partnerOrganizations.find((org) => org.isPrimary) ||
    user.partnerOrganizations[0]
  );
}

export function getDefaultPostLoginDestination(user) {
  if (!user) {
    return "#/";
  }

  if (hasInternalAdminAccess(user)) {
    return null;
  }

  if (user.permissions?.includes("partner_dashboard.view")) {
    if (user.partnerOrganizations?.length > 0) {
      return automapAdminPortalPath("dashboard");
    }
  }

  if (
    user.permissions?.includes("saved_searches.view") ||
    user.permissions?.includes("favorites.view")
  ) {
    return "/account/dashboard";
  }

  return "#/";
}
